class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (event) => {
      if (event.target.id === 'CartDrawer-Overlay') {
        event.preventDefault();
        this.close();
      }
    });

    this.addEventListener('change', (event) => {
      const select = event.target.closest('[data-cart-addon-variant]');
      if (!select) return;

      this.updateAddonButton(select);
    });

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-addon-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      this.addAddonToCart(button);
    });

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-upgrade-to-subscription]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      this.upgradeToSubscription(button);
    });
  }

  connectedCallback() {
    this.initAddonButtons();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#el-cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    /* iOS-safe scroll lock: save position then fix body in place */
    // const scrollY = window.scrollY;
    // document.body.dataset.drawerScrollY = scrollY;
    // document.body.style.position = 'fixed';
    // document.body.style.top      = `-${scrollY}px`;
    // document.body.style.width    = '100%';
    document.documentElement.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    /* Restore scroll position after releasing fixed lock */
    // const scrollY = parseInt(document.body.dataset.drawerScrollY || '0', 10);
    // document.body.style.position = '';
    // document.body.style.top      = '';
    // document.body.style.width    = '';
    // window.scrollTo(0, scrollY);
    document.documentElement.style.overflow = '';

  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    if (typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    this.getSectionsToRender().forEach((section => {
      const raw = parsedState.sections && parsedState.sections[section.id];
      if (!raw) return;
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      const selector = section.selector || '.shopify-section';
      const inner = this.getSectionInnerHTML(raw, selector);
      if (inner == null) return;
      sectionElement.innerHTML = inner;
    }));

    setTimeout(() => {
      if (typeof window.initCartUpsellCarousel === 'function') {
        window.initCartUpsellCarousel(this);
      }

      this.initAddonButtons();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'el-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'el-cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  initAddonButtons() {
    this.querySelectorAll('[data-cart-addon-variant]').forEach((select) => {
      this.updateAddonButton(select);
    });
  }

  updateAddonButton(select) {
    const addon = select.closest(".cd-addon");
    if (!addon) return;

    const button = addon.querySelector("[data-cart-addon-add]");
    const price = addon.querySelector("[data-cart-addon-price]");
    const comparePrice = addon.querySelector("[data-cart-addon-compare-price]");
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) return;

    const isAvailable = selectedOption.dataset.available === "true";

    if (price) {
      price.textContent = selectedOption.dataset.price
        ? `${selectedOption.dataset.price}`
        : "";
    }

    if (comparePrice) {
      const compare = selectedOption.dataset.comparePrice;

      comparePrice.textContent = compare || "";
      comparePrice.hidden = !compare || compare === selectedOption.dataset.price;
    }

    if (button) {
      if (!button.dataset.defaultText) {
        button.dataset.defaultText = button.textContent.trim();
      }

      button.disabled = !isAvailable;
      button.textContent = isAvailable ? button.dataset.defaultText : "Not available";
    }
  }

  async addAddonToCart(button) {
    if (button.disabled) return;

    const addon = button.closest(".cd-addon");
    const select = addon?.querySelector("[data-cart-addon-variant]");
    const variantId = Number(select?.value);

    if (!variantId || Number.isNaN(variantId)) return;

    button.disabled = true;
    button.classList.add("is-loading");

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: this.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        console.error("Add-on cart error:", parsedState);
        return;
      }

      this.renderContents(parsedState);
    } catch (error) {
      console.error("Add-on fetch error:", error);
    } finally {
      button.disabled = false;
      button.classList.remove("is-loading");
    }
  }

  async upgradeToSubscription(button) {
    if (button.disabled) return;

    const upgradeCard = button.closest('[data-subscription-upgrade]');
    if (!upgradeCard) return;

    const lineKey = upgradeCard.dataset.lineKey;
    const quantity = Number(upgradeCard.dataset.lineQuantity || 1);
    const sellingPlanId = Number(upgradeCard.dataset.sellingPlanId);
    const errorElement = upgradeCard.querySelector(
      '[data-subscription-upgrade-error]'
    );

    if (!lineKey || !sellingPlanId || Number.isNaN(sellingPlanId)) {
      if (errorElement) {
        errorElement.textContent =
          'This subscription option is currently unavailable.';
        errorElement.hidden = false;
      }

      return;
    }

    const originalText = button.textContent.trim();

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Upgrading...';

    if (errorElement) {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    try {
      const sections = this.getSectionsToRender().map((section) => section.id);

      const response = await fetch(
        window.Shopify.routes.root + 'cart/change.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: quantity,
            selling_plan: sellingPlanId,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        }
      );

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(
          parsedState.description ||
          parsedState.message ||
          'Unable to upgrade this item.'
        );
      }

      this.renderContents(parsedState);
    } catch (error) {
      console.error('Subscription upgrade error:', error);

      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;

      if (errorElement) {
        errorElement.textContent =
          error.message || 'Unable to upgrade. Please try again.';
        errorElement.hidden = false;
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'el-cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'el-cart-icon-bubble',
        section: 'el-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  /**
   * Main cart page uses <cart-items>; the drawer uses <cart-drawer-items>.
   * Refresh from the cart-drawer section so markup and line ids stay correct.
   */
    onCartUpdate() {
      const path = window.location.pathname;
      const url = `${path}?sections=el-cart-drawer,el-cart-icon-bubble&sections_url=${encodeURIComponent(path)}`;

      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          const drawerHtml = response && response['el-cart-drawer'];
          const bubbleHtml = response && response['el-cart-icon-bubble'];

          if (drawerHtml) {
            const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
            const source = doc.querySelector('cart-drawer-items');

            if (source) {
              this.innerHTML = source.innerHTML;
            }
          }

          if (bubbleHtml) {
            const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');

            const newBubble =
              doc.querySelector('#el-cart-icon-bubble') ||
              doc.querySelector('.shopify-section');

            const currentBubble = document.getElementById('el-cart-icon-bubble');

            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);